import React from "react";
import api from "../../../api";

import { Segment, Table, Pagination, Message } from "semantic-ui-react";
import { DatatableTable } from "./DatatableTable";
import ConfirmationModal from "../../Integration/DataConnections/ConfirmationModal";


import ChatFilter from "./ChatFilter";
import { DatatableRow } from "./DatatableRow";
import { DatatablePageSizeSelect } from "./DatatablePageSizeSelect";
import Modal from "../ChatSetup/components/Modal";
import AdditionalCaptured from "./AdditionalCaptured";

import ViewDetails from "./ViewDetails";
import ViewNotes from "./ViewNotes";

import ChatStatus from "./ChatStatus";
import { CSVLink } from "react-csv";
import Notes from "./Notes";
import DialogBoxHipaaPin from "../DialogBoxHipaaPin";
import DialogBoxDetail from "../Settings/ManageUser/DialogBoxDetail";
import config from "../../../config/index";
import CustomErrorField from "../../Form/CustomErrorField";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomModel from "../CompletedChats/CustomModel";
import WebhookDataContent from "../CommonComponents/WebhookDataContent";
import moment from 'moment';
// below css not applying in modal
import "./aicall.css";
const tableHeader = [
    {
        title: "Actions",
        width: "1",
        sort: "",
        checkbox: true,
    },
    {
        title: "Date",
        width: "3",
        sort: "created_at",
    },
    {
        title: "From Number",
        width: "1",
        sort: "",
    },
    {
        title: "Call Transcript",
        width: "2",
        sort: "",
    },
    {
        title: "Call Recording",
        width: "1",
        sort: "",
    },
    {
        title: "Summary",
        width: "2",
        sort: "",
    },
    {
        title: "Transcript Status",
        width: "3",
        sort: "chat_status",
    },
    {
        title: "Team Notes",
        width: "3",
        sort: "",
    },
    {
        title: "Call Forward To",
        width: "1",
        sort: "",
    },

    {
        title: "AI Call Time",
        width: "1",
        sort: "",
    },

    {
        title: "Call Status",
        width: "1",
        sort: "",
    },


    {
        title: "Parsed Data",
        width: "2",
        sort: "",
    },
    {
        title: "Notifications",
        width: "2",
        sort: "",
    },
    {
        title: "Webhook data",
        width: "2",
        sort: "",
    },
    {
        title: "Log ID",
        width: "2",
        sort: "",
    }

];
const outbound_tableHeader = [
    {
        title: "Actions",
        width: "1",
        sort: "",
        checkbox: true,
    },
    {
        title: "Date",
        width: "3",
        sort: "created_at",
    },
    {
        title: "From Number",
        width: "1",
        sort: "",
    },
    {
        title: "Call Transcript",
        width: "2",
        sort: "",
    },
    {
        title: "Call Recording",
        width: "1",
        sort: "",
    },
    {
        title: "Summary",
        width: "2",
        sort: "",
    },
    {
        title: "Transcript Status",
        width: "3",
        sort: "chat_status",
    },
    {
        title: "Team Notes",
        width: "3",
        sort: "",
    },
    {
        title: "Call Forward To",
        width: "1",
        sort: "",
    },

    {
        title: "AI Call Time",
        width: "1",
        sort: "",
    },

    {
        title: "Call Status",
        width: "1",
        sort: "",
    },


    {
        title: "Parsed Data",
        width: "2",
        sort: "",
    },

    {
        title: "Notifications",
        width: "2",
        sort: "",
    },
    {
        title: "Webhook data",
        width: "2",
        sort: "",
    },

    {
        title: "Log ID",
        width: "2",
        sort: "",
    }

];

const sms_tableHeader = [
    {
        title: "Actions",
        width: "1",
        sort: "",
        checkbox: true,
    },
    {
        title: "Date",
        width: "3",
        sort: "created_at",
    },
    {
        title: "From Number",
        width: "1",
        sort: "",
    },
    {
        title: "Sent To",
        width: "1",
        sort: "",
    },
    {
        title: "SMS Transcript",
        width: "2",
        sort: "",
    },
    {
        title: "Message Summary",
        width: "2",
        sort: "",
    },
    {
        title: "Conversation Status",
        width: "3",
        sort: "status",
    },
    {
        title: "Team Notes",
        width: "3",
        sort: "",
    },
    {
        title: "Message Count",
        width: "1",
        sort: "conversation_count",
    },
    {
        title: "Parsed Data",
        width: "2",
        sort: "",
    },
    {
        title: "Notifications",
        width: "2",
        sort: "",
    },
    {
        title: "Webhook data",
        width: "2",
        sort: "",
    },
    {
        title: "Log ID",
        width: "2",
        sort: "",
    },
];

const queryParams = [
    "_limit",
    "_order",
    "_sort",
    "q",
    "_page",
    "chatstatus",
    "chatfrequency",
    "time_zone",
    "startdaterange",
    "enddaterange",
];
const twl_errs={13224:"Twilio does not support calling this number or the number is invalid",13223:"Twilio does not support calling this number or the number is invalid",13226:"Invalid country code",30005:"Unknown destination handset",30006:"Landline or unreachable carrier",30001:"Queue overflow",30003:"Unreachable destination handset",30014:"To attributes are Invalid"};

const safeParseJsonArray = (input, fallback = []) => {
    if (input == null) return fallback;
    if (Array.isArray(input)) return input;
    if (typeof input === "object") return input;
    if (typeof input !== "string") return fallback;
    try {
        const parsed = JSON.parse(input);
        return Array.isArray(parsed) ? parsed : fallback;
    } catch (e) {
        return fallback;
    }
};

const normalizeSmsChatLogItem = (item) => {
    const id = item.id ?? item.auto_id;
    const initialMessageSid =
        item.initial_message_sid ?? item.log_id ?? item.call_recording_sid ?? "";
    const customerPhone = item.customer_phone || item.call_from || item.phone || "";
    const businessPhone = item.business_phone || item.forwarded || "";
    const summaryText =
        item.last_ai_response || item.initial_message || item.summary || "";
    const statusRaw = item.status ?? item.chatstatus ?? item.chat_status ?? "";
    const statusLabel =
        item.status_label || item.message_status || item.chat_status || statusRaw || "";

    return {
        ...item,
        id,
        auto_id: id,
        log_id: initialMessageSid,
        initial_message_sid: initialMessageSid,
        call_recording_sid: initialMessageSid,
        customer_phone: customerPhone,
        call_from: customerPhone,
        phone: customerPhone,
        business_phone: businessPhone,
        forwarded: businessPhone,
        conversation_history: safeParseJsonArray(
            item.conversation_history ?? item.question_answer,
            []
        ),
        summary: summaryText,
        last_ai_response: item.last_ai_response || "",
        initial_message: item.initial_message || "",
        ai_call_duration: item.conversation_count ?? item.ai_call_duration ?? "",
        conversation_count: item.conversation_count ?? item.ai_call_duration ?? 0,
        conversation_limit: item.conversation_limit,
        status: statusRaw,
        chatstatus: statusRaw,
        chat_status: statusLabel,
        status_label: statusLabel,
        message_status: item.message_status || statusLabel,
        channel: item.channel || "sms",
        voiceType: item.channel || item.voiceType || "sms",
        chat_logo: item.chat_logo ?? item.chatLogo ?? "",
        chatLogo: item.chat_logo ?? item.chatLogo ?? "",
        hippa_on: item.hippa_on ?? item.hippaOn ?? "none",
        hippaOn: item.hippa_on ?? item.hippaOn ?? "none",
        hippa: item.hippa ?? false,
        last_customer_message: item.last_customer_message || "",
        last_interaction_at: item.last_interaction_at || "",
        status_badge: item.status_badge,
        channel_badge: item.channel_badge,
        tags: item.tags,
        transcript: item.transcript,
        summary_transcript: item.summary_transcript,
        view_details: item.view_details,
        checked: item.checked ?? false,
        custom_capture: item.parse_data ?? "",
        team_notes: item.team_notes ?? false,
    };
};

const getSmsTranscriptContent = (list) => {
    const html = list?.transcript?.data;
    const htmlTrans = list?.transcript?.dataTrans;
    if (html) {
        return { data: html, dataTrans: htmlTrans || html };
    }
    return {
        data: "<div>No transcript available.</div>",
        dataTrans: "<div>No transcript available.</div>",
    };
};

const getSmsSummaryContent = (list) => {
    const html = list?.summary_transcript?.data;
    const htmlTrans = list?.summary_transcript?.dataTrans;
    if (html) {
        return { data: html, dataTrans: htmlTrans || html };
    }
    const summaryText =
        list?.last_ai_response || list?.initial_message || list?.summary;
    if (summaryText) {
        const wrapped = `<div style="font-size: 14px;color:#6F6969; font-weight: 600;">${summaryText}</div>`;
        return { data: wrapped, dataTrans: wrapped };
    }
    return {
        data: "<div>No summary available.</div>",
        dataTrans: "<div>No summary available.</div>",
    };
};

export default class DatatableList extends React.Component {
    #oneMonthAgo = moment().subtract(1, 'month').format('MM/DD/YYYY');
    #today =moment().format('MM/DD/YYYY');
    constructor(props) {
        super(props);
        this.state = {
            lists: [],
            _sort: "id",
            _page: 1,
            _order: "desc",
            _limit: 10,
            q: "",
            chatstatus: "all",
            chatfrequency: "daterange",
            startdaterange: this.#oneMonthAgo,
            enddaterange: this.#today,
            totalCount: 0,
            loading: false,
            modalstatus: false,
            modaltitle: null,
            modalbuttonmsg: {},
            modalType: null,
            modalfooter: "",
            modalBody: "",
            datatableHeader: null,
            datatableRows: null,
            modalErrorMsg: false,
            modalstatusAddEdit: false,
            modaldata: {},
            modalFormLoader: false,
            selectedOptions: [],
            accessModuleList: [],
            auto_id: "",
            modalTranscript: "",
            csvdata: [],
            hipaaValidateObject: {},
            modalstatusHIPAA: false,
            user: props.user,
            last_call_recording: '',
            reportcommnet: '',
            reporterror: false,
            responseError: false,
            category: '',
            categoryError: false,
            reportstatus: '',
            modalBtn:true,
            oldTxt:'',
            custom_search:[],
            custom_searchdata:[],
            parsed_data:{},
            openCustomModal:false,
            curid:"",
            existdata:[],
            parsed_config:[],
            is_required:0,
            date_required:0,
            user_timezone:'',
            job_description:"",
            use_address:"",
            parsebtnName:"",
            requestedFiles:[],
            alert_msg:'',
            emails: [],
            emailList:[],
            errors: {},
            isModalOpen: false, selectedId: null,
            voiceStatusList: [],
            showNotesForm:false,
            confirmDeleteNoteShow: false,
            confirmDeleteNoteId: null,
            maxWidth:600,
            workspaceList: [],
            selectedWorkspace: ""
        };

        if(this.props.user.user_id && this.props.user.user_id==8830){
            let outcome_pos=10;
             if(tableHeader[outcome_pos].title=='Parsed Data'){
                tableHeader.splice(outcome_pos,0,{
                    title: "Call Outcome",
                    width: "3",
                    sort: "",
                });
            }
        }
        this.csvLink = React.createRef();
    }

    componentDidMount() {
        if (this.isSmsMode()) {
            this.fetchVoiceChatStatus();
        }
        this.loadData({});
        if (!this.isSmsMode()) {
            this.fetchVoiceChatStatus();
        }
    }

    getSmsSelectedChatStatus = (list) =>
        list?.status ?? list?.chatstatus ?? list?.transcript?.status ?? "";

    buildSmsChatLogParams = (params, state) => {
        const formatDate = (value) => moment(value, "MM/DD/YYYY").format("YYYY-MM-DD");
        const sortKey = params._sort || state._sort;
        const smsSortKey =
            sortKey === "date_added"
                ? "created_at"
                : sortKey === "chat_status"
                ? "status"
                : sortKey;
        const smsParams = {
            q: params.q ?? state.q ?? "",
            _limit: params._limit ?? state._limit,
            _page: params._page ?? state._page,
            _order: params._order ?? state._order,
            _sort: smsSortKey,
            chatfrequency: params.chatfrequency ?? state.chatfrequency,
            startdaterange: formatDate(params.startdaterange ?? state.startdaterange),
            enddaterange: formatDate(params.enddaterange ?? state.enddaterange),
            time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        const workspaceId = params.workspace_id ?? state.selectedWorkspace;
        if (workspaceId) {
            smsParams.workspace_id = workspaceId;
        }
        const chatstatus = params.chatstatus ?? state.chatstatus;
        if (chatstatus && chatstatus !== "all") {
            smsParams.chatstatus = chatstatus;
        }
        return smsParams;
    };

    loadSmsChatLogData = (newState, params) => {
        const smsParams = this.buildSmsChatLogParams(params, newState);

        this.setState(newState, () => {
            this.setState({ loading: true });
            api.outbound
                .getSmsCampaignChatLog(smsParams)
                .then((data) => {
                    try {
                        const payload = data?.data || data;
                        const list = (payload?.list || []).map(normalizeSmsChatLogItem);
                        const totalrecord = payload?.totalrecord ?? payload?.total ?? 0;
                        const workspaceList = payload?.workspaceList;

                        let datatableRowstemp;
                        if (totalrecord) {
                            datatableRowstemp = list.map((item, index) => this.buildDatatableRow(item, index));
                        } else {
                            datatableRowstemp = (
                                <Table.Row>
                                    <Table.Cell colSpan={this.getTableHeader().length} textAlign="center">
                                        No record found.
                                    </Table.Cell>
                                </Table.Row>
                            );
                        }

                        const nextState = {
                            datatableRows: datatableRowstemp,
                            totalCount: totalrecord,
                            lists: list,
                            requestedFiles: payload?.requested_file ? payload.requested_file : [],
                            loading: false,
                        };
                        if (workspaceList) {
                            nextState.workspaceList = workspaceList;
                        }
                        this.setState(nextState);
                    } catch (err) {
                        this.setState({ loading: false });
                    }
                })
                .catch((error) => {
                    this.setState({
                        loading: false,
                        lists: [],
                        totalCount: 0,
                        datatableRows: (
                            <Table.Row>
                                <Table.Cell colSpan={this.getTableHeader().length} textAlign="center">
                                    No record found.
                                </Table.Cell>
                            </Table.Row>
                        ),
                    });
                });
        });
    };

    isSmsMode = () => this.props.call_type === "sms";

    getApiCallType = () => (this.isSmsMode() ? "outbound_sms" : this.props.call_type);

    getTableHeader = () => {
        if (this.isSmsMode()) return sms_tableHeader;
        if (this.props.call_type === "outbound") return outbound_tableHeader;
        return tableHeader;
    };

    buildDatatableRow = (list, index) => (
        <DatatableRow
            channgeEvent={this.checkboxChangeEvent}
            key={list.auto_id || index}
            list={list}
            viewAdditionalCaptured={this.viewAdditionalCaptured}
            viewDetails={this.viewDetails}
            viewSummary={this.viewSummary}
            viewRecording={this.viewRecording}
            viewNotes={this.viewNotes}
            viewNoteshtml={this.viewNotesHtml}
            openHipaaRow={this.openHipaaRow}
            viewPaerseData={this.viewPaerseData}
            reGenerateParseData={this.reGenerateParseData}
            notificationDetails={this.notificationDetails}
            viewWebhookData={this.viewWebhookData}
            user_id={this.props.user.user_id}
            call_type={this.isSmsMode() ? "sms" : this.props.call_type}
        />
    );

    static directionConverter(order) {
        if (order === "asc") {
            return "ascending";
        } else if (order === "desc") {
            return "descending";
        } else {
            return null;
        }
    }
    fetchVoiceChatStatus = async () => {
        try {
            const data = await api.transcriptchatlist.fetchChatstatus({ type: "voice" });
             this.setState({ voiceStatusList: data });
        } catch (error) {
        }
    };

    handleSort = (clickedColumn) => {
        const { _sort, _order } = this.state;

        let newOrder = _order === "asc" ? "desc" : "asc";
        if (_sort !== clickedColumn) {
            newOrder = "asc";
        }

        this.loadData({
            _sort: clickedColumn,
            _page: 1,
            _order: newOrder,
        });
    };

    onChangeLimit = (event, data) => {
        if (data.value !== this.state._limit) {
            this.loadData({ _limit: data.value, _page: 1 });
        }
    };
    addEmailField = () => {
        this.setState((prevState) => ({
            emails: [...prevState.emails, { email: "", name: "" }]
        }), () => {
            this.updatemodelBody();
        });
    };
   removeEmailField = (index, event) => {
    if (event) event.preventDefault();
    if (event) event.stopPropagation();
    this.setState((prevState) => {
        const updatedEmails = [...prevState.emails];
        updatedEmails.splice(index, 1);
        return {
            emails: updatedEmails,
            modalBtn: true
        };
    }, () => {
        this.updatemodelBody();
    });
};

    handleEmailChange = (index, event) => {
        const newEmails = [...this.state.emails];
        newEmails[index].email = event.target.value;
        this.setState({ emails: newEmails,modalBtn:false}, () => {
            this.updatemodelBody();
        });
    };
    handleNameChange = (index, event) => {
        const newEmails = [...this.state.emails];
        newEmails[index].name = event.target.value;
        this.setState({ emails: newEmails,modalBtn:false }, () => {
            this.updatemodelBody();
        });
    };
    onSubmitFilter = (filter, val) => {

        if (filter == "chatfrequency") {
            this.setState({
                startdaterange: "",
                enddaterange: "",
            },()=>{
                this.loadData({ [filter]: val, _page: 1 });
            });
        }else if(filter=='q'){
            this.setState({
                q: val
            },()=>{
                this.loadData({ [filter]: val,  _page: 1 });
            });
        } else if (filter === "workspace_id") {

            this.setState({
                selectedWorkspace: val
            },()=>{
                this.loadData({ [filter]: val, _page: 1 });
            });
        } else if (filter === "chatstatus") {
            this.setState({ chatstatus: val }, () => {
                this.loadData({ chatstatus: val, _page: 1 });
            });
        }
        //if (filter !== this.state.q) {
       // this.loadData({ [filter]: val, _page: 1 });
        // }
    };

    onSubmitFilterDateReange = (parmas) => {
        this.loadData({
            chatfrequency: parmas["chatfrequency"],
            startdaterange: parmas["startdaterange"],
            enddaterange: parmas["enddaterange"],
            _page: 1,
        });
    };

    onChangePage = (event, data) => {
        const { activePage } = data;
        if (activePage !== this.state._page) {
            this.loadData({ _page: activePage });
        }
    };

    modalClose = (flag, fm) => {
        this.setState({
            modalstatus: false,
            modalstatusAddEdit: false,
            modaltitle: "",
            modalmessage: "",
            modalbuttonmsg: {},
            modalType: "",
            modaldata: {},
            selectedOptions: [],
            emails: [],
        });
    };

    loadData = (params) => {
        const newState = Object.assign({}, this.state, params, { loading: false });
        queryParams.forEach(function (element) {
            if (!(element in params)) {
                params[element] = newState[element];
            }
        });

        if (this.isSmsMode()) {
            this.loadSmsChatLogData(newState, params);
            return;
        }

        let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
        let clientTimeZone = u.substring(0, 3) + ":" + u.substring(3, u.length);
        let time_zone = clientTimeZone;

        params["time_zone"] = time_zone;
        params["call_type"] = this.getApiCallType();
        params["workspace_id"] = this.state.selectedWorkspace;

        const esc = encodeURIComponent;
        const query = Object.keys(params)
            .map((k) => esc(k) + "=" + esc(params[k]))
            .join("&");

        let totalCountQuery = "";
        if (params.q !== "") {
            totalCountQuery = `q=${params.q}`;
        }
        this.setState(newState, () => {
            this.setState({ loading: true });
            api.transcriptchatlist.getVoiceChatData(query).then((data) => {
                try {
                    let datatableRowstemp;
                    this.setState({ lists: data.data.list, workspaceList: data.data.workspaceList });

                    if (data.data.totalrecord) {

                        datatableRowstemp = this.state.lists.map((list, index) =>
                            this.buildDatatableRow(list, index)
                        );
                    } else {
                        datatableRowstemp = (
                            <Table.Row>
                                <Table.Cell colSpan={this.getTableHeader().length} textAlign="center">
                                    No record found.
                                </Table.Cell>
                            </Table.Row>
                        );
                    }
                    this.setState({
                        datatableRows: datatableRowstemp,
                        totalCount: data.data.totalrecord,
                        lists: data.data.list,
                        requestedFiles:data.data?.requested_file ? data.data?.requested_file:[],
                    });
                } catch (err) {
                }
                const newState = Object.assign({}, this.state, params, {
                    loading: false,
                });
                this.setState(newState);
            });
        });
    };
    copyurl = (proxyUrl) => {
        navigator.clipboard.writeText(proxyUrl);
        const copyp = document.getElementById('copyurlsuccess');
        copyp.style.display = 'block';
        setTimeout( () => {
            copyp.style.display = 'none';
        }, 2000);
    }
    viewRecording = (rsid, call_recording_sid, viewUrl) => {
        if (!rsid) {
            this.setState({
                loading: false,
                modalstatus: true,
                modaltitle: "",
                modalfooter: "",
                modalbody: (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <span style={{ fontWeight: 600, fontSize: 14, color: 'red' }}>Call recording not available.</span>
                    </div>

                ),
                modalTranscript: false
            }, () => {
                this.changeTableRowBackground(call_recording_sid);
            });
            return false;
        }
        try {
            // rsid = audio proxy URL for <audio src>; viewUrl = shareable HTML view page
            const audioUrl = rsid;
            const shareUrl = viewUrl || rsid;
            this.setState({
                last_call_recording: `recording_play_${call_recording_sid}`,
                loading: false,
                modalstatus: true,
                modaltitle: "Call recording",
                modalfooter: "",
                modalbody: (
                    <div style={this.props.isPLG ? { paddingLeft: '21px' } : undefined}>
                        <div class="box-title" id="copyurlsuccess" style={{display: 'none', color: 'green'}}>URL Copied</div>
                        <div style={{ display: 'flex', justifyContent: this.props.isPLG ? 'flex-start' : 'center', alignItems: this.props.isPLG ? 'flex-start' : 'center', flexDirection: 'column'}}>
                        <div onClick={() => this.copyurl(shareUrl)} title="Copy" className="alert" style={{backgroundColor: 'aliceblue', cursor: 'pointer', overflowWrap: 'anywhere', alignItems: 'center', columnGap: 14}}>
                                {shareUrl} <i className="fa fa-copy"></i>
                            </div>
                            <audio key={`recording_play_${call_recording_sid}`} id={`recording_play_${call_recording_sid}`} controls>
                               
                                 <source src={audioUrl} />
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    </div>
                ),
                modalTranscript: false
            }, () => {
                this.changeTableRowBackground(call_recording_sid);
            });
        } catch (err) { }
    }

    translate = () => {
        this.setState({
            showenglish:!this.state.showenglish
        })
    }
    viewDetails = (auto_id) => {
        const recordlist = this.state.lists.findIndex(
            (list) => list.auto_id === auto_id || list.id === auto_id
        );
        if (recordlist < 0) return;

        if (this.isSmsMode()) {
            const list = this.state.lists[recordlist];
            const { data: detailHtml, dataTrans: detailTrans } = getSmsTranscriptContent(list);
            const autoId = list.auto_id ?? list.id;

            this.setState(
                {
                    loading: false,
                    modalstatus: true,
                    modaltitle: "",
                    modalfooter: "",
                    auto_id: autoId,
                    custom_search: list.custom_search ?? [],
                    custom_searchdata: list.search_data ?? [],
                    parsed_data: list.parsed_data ?? {},
                    curid: autoId,
                    existdata: list.exist_data ?? [],
                    parsed_config: list.parsedconfig ?? [],
                    is_required: list.is_required ?? 0,
                    date_required: list.date_required ?? 0,
                    user_timezone: list.timezone ?? "",
                    job_description:
                        list.last_ai_response || list.initial_message || list.summary || "",
                    use_address: list.use_address ?? "",
                    modalbody: (
                        <ViewDetails
                            detaildata={detailHtml}
                            detaildataTrans={detailTrans}
                            auto_id={autoId}
                            updatenote={this.updateNote}
                            custom_search={list.custom_search}
                            // Translate loads a voice call by id, so it must stay off for SMS rows.
                            showtranslate={false}
                            showNotesForm={this.showNotesForm}
                        />
                    ),
                    modalTranscript: (
                        <ChatStatus
                            chatRef="sms_chat_log"
                            auto_id={autoId}
                            selected_chat={list.chatstatus ?? ""}
                            list={this.state.voiceStatusList}
                        />
                    ),
                    hideSmsTranscriptControls: false,
                },
                () => this.changeTableRowBackground(autoId)
            );
            return;
        }

        api.transcriptchatlist.viewVoiceChatDetails({ auto_id: auto_id, type: 'question_answer' }).then((data) => {
            try {
                this.setState({
                    loading: false,
                    modalstatus: true,
                    modaltitle: "",
                    modalfooter: "",
                    auto_id: auto_id,
                    custom_search:data.custom_search,
                    custom_searchdata:data.search_data,
                    parsed_data:data.parsed_data,
                    curid:auto_id,
                    existdata:data.exist_data,
                    parsed_config:data.parsedconfig,
                    is_required:data.is_required,
                    date_required:data.date_required,
                    user_timezone:data.timezone,
                    job_description: this.state.lists[recordlist].summary,
                    use_address:data.use_address,
                    modalbody: (
                        <ViewDetails
                            detaildata={data.data.data}
                            detaildataTrans={data.data.dataTrans}
                            auto_id={auto_id}
                            updatenote={this.updateNote}
                            custom_search={data.data.custom_search}
                            openCustomPopup={this.openCustomPopup}
                            showtranslate={true}
                            showNotesForm={this.showNotesForm}
                        ></ViewDetails>
                    ),
                    modalTranscript: (
                        <ChatStatus
                        chatRef="live_chat_log"
                        auto_id={auto_id}
                        selected_chat={data.data.chatstatus}
                        list={this.state.voiceStatusList}
                      />
                    ),
                }, () => {
                    this.changeTableRowBackground(auto_id);
                });
            } catch (err) { }
        });
    };

    changeTableRowBackground = (auto_id) => {
        const allTableRows = document.querySelectorAll('.table-row-ai');
        allTableRows.forEach((row) => {
            row.classList.remove('active');
        });
        const activeRow = document.querySelector(`.tr__${auto_id}`);
        if(activeRow){
         activeRow.classList.add('active');
        }
    }

    getDetails = (auto_id) => {
        this.setState({loading:true});
        let recordlist = this.state.lists.findIndex(
            (list) => list.auto_id === auto_id
        );

        api.transcriptchatlist.viewVoiceChatDetails({ auto_id: auto_id, type: 'question_answer' }).then((data) => {
            try {
                if(data.status){
                    this.setState({
                        loading: false,
                        custom_search:data.custom_search,
                        custom_searchdata:data.search_data,
                        parsed_data:data.parsed_data,
                        curid:auto_id,
                        existdata:data.exist_data,

                    });
                    return true;
                }
                return false;

            } catch (err) {
                return false;
            }
        });
    };

    reGenerateParseData = (logid) => {
        this.setState({
            loading : true
        })
        api.transcriptchatlist.reGenerateParseData({logid: logid}).then((res) => {
            if (res.status) {
                const allList = this.state.lists;
                const findIndex = allList.findIndex((item, index) => item.auto_id == logid);
                allList[findIndex].custom_capture = res.parse_data;
                this.setState({
                    lists: allList,
                    loading : false
                });
            }else{
                this.setState({
                    loading : false
                });
            }
            toast.success(res.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",

            });

        }).catch((err) => {
            this.setState({
                loading : false
            })
        })
    }
    addZipLocation=(data,parsed_config,isAddress)=>{
        if (isAddress && Array.isArray(parsed_config)) {
            for (let rule of parsed_config) {
                if (rule.isZipCode && rule.is_address && Array.isArray(rule.map)) {
                    let rulename=rule.name ? rule.name.trim() : '';
                    let gpt_value=typeof data[rulename]!='undefined' ? data[rulename] : '';
                    for (let mapItem of rule.map) {
                        const zipLocationKey = mapItem.value;
                        const zipCodeKey = mapItem.key;
                        if(zipCodeKey==gpt_value){
                            return {value:zipLocationKey,keyname:rulename,isZipCode:rule.isZipCode};
                        }

                    }
                }
            }
        }else{
            return {value:'N/A',keyname:'',isZipCode:false};
        }
          return {value:'N/A',keyname:'',isZipCode:false};
    }

    viewPaerseData = (data,id) => {
        this.setState({loading:true,parsebtnName:"parsebtn"});
        let recordlist = this.state.lists.findIndex(
            (list) => list.auto_id === id
        );
        if (data) {
            try {
                data = JSON.parse(data);
            } catch (error) {
                data = {}
            }
            data = data == null ? {} : data;

            if (this.isSmsMode()) {
                this.setState({
                    loading: false,
                    modalstatus: true,
                    modaltitle: "",
                    modalfooter: "",
                    modalbody: Object.keys(data).length ? (
                        <Table id="additional_captured">
                            <Table.Body>
                                {Object.keys(data).map((key, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell>{key}</Table.Cell>
                                        <Table.Cell>{typeof data[key] === 'string' ? data[key] : JSON.stringify(data[key])}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    ) : (
                        <h2>No data available.</h2>
                    ),
                    modalTranscript: false,
                }, () => this.changeTableRowBackground(id));
                return;
            }

            api.transcriptchatlist.viewVoiceChatDetails({ auto_id: id, type: 'question_answer' }).then((data1) => {
                try {
                    let  parsed_config=typeof data1.parsedconfig!="undefined" && data1.parsedconfig ? data1.parsedconfig : [];
                    let isAddress=typeof data1?.use_address!='undefined' ? data1.use_address : false;
                    let newData=this.addZipLocation(data,parsed_config,isAddress);
                    let stateobj = {
                        loading: false,
                        modalstatus: true,
                        modaltitle: "",
                        modalfooter: "",
                        custom_search: data1.custom_search,
                        custom_searchdata: data1.search_data,
                        parsed_data: data1.parsed_data,
                        curid: id,
                        existdata: data1.exist_data,
                        parsed_config: data1.parsedconfig,
                        is_required: data1.is_required,
                        date_required: data1.date_required,
                        user_timezone: data1.timezone,
                        job_description: this.state.lists[recordlist].summary,
                        use_address: data1.use_address,
                        modalbody: (() => {
                            if (Object.keys(data).length) {
                                return (
                                    <Table id="additional_captured">
                                        <Table.Body>
                                            {Object.keys(data).map((key, index) => {
                                                if (newData && newData?.isZipCode && isAddress && newData?.keyname === key) {
                                                    return (
                                                        <>
                                                        <Table.Row key={index}>
                                                            <Table.Cell>{key}</Table.Cell>
                                                            <Table.Cell>{typeof data[key] === 'string' ? data[key] : JSON.stringify(data[key])}  </Table.Cell>
                                                        </Table.Row>
                                                         <Table.Row key={999}>
                                                            <Table.Cell>Zip code location</Table.Cell>
                                                            <Table.Cell>{newData.value}  </Table.Cell>
                                                        </Table.Row>
                                                        </>
                                                    );
                                                } else {
                                                    return (
                                                        <Table.Row key={index}>
                                                            <Table.Cell>{key}</Table.Cell>
                                                            <Table.Cell>{typeof data[key] === 'string' ? data[key] : JSON.stringify(data[key])}</Table.Cell>
                                                        </Table.Row>
                                                    );
                                                }
                                            })}
                                        </Table.Body>
                                    </Table>
                                );
                            } else {
                                return (
                                    <>
                                        <h2>No data available.</h2>
                                    </>
                                );
                            }
                        })(),
                        modalTranscript: false
                    };

                    this.setState(stateobj,() => {this.changeTableRowBackground(id);});
                    return false;

                } catch (err) {

                }
            });

        }else{
            this.setState({
                loading: false,
                modalstatus: true,
                modaltitle: "",
                modalfooter: "",
                modalbody: (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <span style={{ fontWeight: 600, fontSize: 14, color: 'red' }}>No data available.</span>
                    </div>

                ),
                modalTranscript: false
            }, () => {
                this.changeTableRowBackground(id);
            });
            return false;
        }
    }

    viewSummary = (auto_id) => {
        if (this.isSmsMode()) {
            const list = this.state.lists.find(
                (item) => item.auto_id === auto_id || item.id === auto_id
            );
            if (!list) return;

            const { data: detailHtml, dataTrans: detailTrans } = getSmsSummaryContent(list);
            const rowId = list.auto_id ?? list.id;

            this.setState(
                {
                    loading: false,
                    modalstatus: true,
                    modaltitle: "Summary",
                    modalfooter: "",
                    auto_id: rowId,
                    modalbody: (
                        <ViewDetails
                            detaildata={detailHtml}
                            detaildataTrans={detailTrans}
                            auto_id={rowId}
                            summary={true}
                            showtranslate={false}
                        />
                    ),
                    modalTranscript: false,
                },
                () => this.changeTableRowBackground(rowId)
            );
            return;
        }

        api.transcriptchatlist.viewVoiceChatDetails({ auto_id: auto_id, type: 'summary' }).then((data) => {
            try {
                this.setState({
                    loading: false,
                    modalstatus: true,
                    modaltitle: "Summary",
                    modalfooter: "",
                    modalbody: (
                        <ViewDetails
                            detaildata={data.data.data}
                            auto_id={auto_id}
                            summary={true}
                            showtranslate={false}
                        ></ViewDetails>
                    ),
                    modalTranscript: false,
                }, () => {
                    this.changeTableRowBackground(auto_id);
                });
            } catch (err) { }
        });
    }

    deleteNotes = (id) => {
        this.setState({
            confirmDeleteNoteShow: true,
            confirmDeleteNoteId: id,
            modalstatus: false,
        });
    }

    confirmDeleteNoteClose = () => {
        this.setState({
            confirmDeleteNoteShow: false,
            confirmDeleteNoteId: null,
        });
    }

    onConfirmDeleteNote = () => {
        const noteId = this.state.confirmDeleteNoteId;
        if (!noteId) {
            return;
        }

        this.setState({ modalFormLoader: true });
        api.transcriptchatlist.deleteNotes({ auto_id: noteId }).then(() => {
            this.setState({
                loading: false,
                modalFormLoader: false,
                confirmDeleteNoteShow: false,
                confirmDeleteNoteId: null,
                modalstatus: false,
                modaltitle: "Team Notes",
            }, this.loadData({}));
        }).catch(() => {
            this.setState({
                modalFormLoader: false,
                confirmDeleteNoteShow: false,
                confirmDeleteNoteId: null,
            });
        });
    }
    viewNotesHtml = async (auto_id) => {
        let recordlist = this.state.lists.findIndex(
            (list) => list.auto_id === auto_id
        );
        const listRow = recordlist >= 0 ? this.state.lists[recordlist] : {};
        const assetPath = (this.props.user?.assetPath || '').replace(/\/$/, '');
        const userChatLogo = this.props.user?.chat_logo
            ? `${assetPath}/images/chatlogo/${this.props.user.chat_logo}`
            : '';
        const chatlogo = listRow.chatLogo || listRow.chat_logo || userChatLogo;
        const company = listRow.company || this.props.user?.company || '';
        api.transcriptchatlist.fetchparticularNotes({
            auto_id: auto_id,
            type: this.isSmsMode() ? "sms" : "voice",
        }).then((data) => {
            this.setState({
                loading: false,
                modalstatus: true,
                modaltitle: "Team Notes",
                modalfooter: "",
                modalbody: (
                    <ViewNotes
                        auto_id={auto_id}
                        data={data}
                        comapny={company}
                        chatlogo={chatlogo}
                        deleteNotes = {this.deleteNotes}
                    ></ViewNotes>
                ),
                modalTranscript: false,
            }, () => {
                this.changeTableRowBackground(auto_id);
            });
        })


    }

    updateNote = (auto_id, value) => {


        let datalist = this.state.lists;

        let recordlist = this.state.lists.findIndex(
            (list) => list.auto_id === auto_id
        );

        datalist[recordlist]["team_notes"] = value;
        this.setState({
            datatableRows: datalist.map((list, index) => (
                <DatatableRow
                    channgeEvent={this.checkboxChangeEvent}
                    key={index}
                    list={list}
                    viewAdditionalCaptured={this.viewAdditionalCaptured}
                    viewDetails={this.viewDetails}
                    viewSummary={this.viewSummary}
                    viewRecording={this.viewRecording}
                    viewNoteshtml={this.viewNotesHtml}
                    openHipaaRow={this.openHipaaRow}
                    viewPaerseData={this.viewPaerseData}
                    reGenerateParseData={this.reGenerateParseData}
                    notificationDetails={this.notificationDetails}
                    viewWebhookData={this.viewWebhookData}
                    user_id={this.props.user.user_id}
                    call_type={this.props.call_type}

                />
            )),
            lists: datalist,
        });
    };

    viewAdditionalCaptured = (auto_id) => {
        let recordlist = this.state.lists.findIndex(
            (list) => list.auto_id === auto_id
        );

        let modaldata = this.state.lists[recordlist]["additionl_captured"];

        this.setState({
            loading: false,
            modalstatus: true,
            modaltitle: "Additional Captured Fields",
            modalfooter: "",
            modalbody: (
                <AdditionalCaptured
                    additional_captured={modaldata}
                ></AdditionalCaptured>
            ),
            modalTranscript: false,
        });
    };

    viewNotes = (auto_id) => {
        try {
            let notes_data = "";
            this.setState({
                loading: false,
                modalstatus: true,
                modaltitle: "Team Notes",
                modalfooter: "",
                modalbody: (
                    <Notes
                        auto_id={auto_id}
                        commentform="false"
                        tableref="chat_log"
                        updatenote={this.updateNote}
                    ></Notes>
                ),
                modalTranscript: false,
                showNotesForm:this.state.showNotesForm
            });
        } catch (err) { }
    };

    showNotesForm = (auto_id) => {
        api.transcriptchatlist.fetchparticularNotes({
            auto_id: auto_id,
            type: this.isSmsMode() ? "sms" : "voice",
        }).then((data) => {
            this.setState({
                loading: false,
                modalstatus: true,
                modaltitle: "Leave Internal Notes",
                modalfooter: "",
                modalbody: (
                    <>
                    {this.updatenotesBody(auto_id)}
                    </>
                ),
                modalTranscript: false,
            }, () => {
                this.changeTableRowBackground(auto_id);
            });
        })
    }
    updatenotesBody = (auto_id) => {
        return (
            <Notes
                auto_id={auto_id}
                updatenote={this.updateNote}
                commentform="true"
                modalClose={this.modalClose}
                notesType={this.isSmsMode() ? "sms" : "voice"}
            />
        )
    }

    modalFooter = (type) => { };

    modalClose = () => {
        const recordingDiv = document.getElementById(this.state.last_call_recording);
        if (recordingDiv) {

            recordingDiv.pause();
            // recordingDiv.src = '';
        }
        this.setState({
            modalstatus: false,
            parse_data:[],
            custom_search:[],
            custom_searchdata:[],
            parsebtnName:"",
            emails: [],
            maxWidth: 600,

        });
    };

    modalFooter = (id, type) => {
        return (
            <div className="modal-footer">
                <button
                    type="button"
                    onClick={() => this.modalClose()}
                    className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
                    data-dismiss="modal"
                >
                    <span>No</span>
                </button>
                <button
                    type="button"
                    onClick={() => this.confirmDelete(this.state.modaldata.id)}
                    className="btn linear-gradient yr-submitbtn btn-sm"
                >
                    <span>Yes</span>
                </button>
            </div>
        );
    };

    modalBody = () => {
        if (this.state.modalType == "job_description") {
            this.getJobDescriptionView(this.state.auto_id);
        }

        if (this.state.modalType == "additional_captured") {
            this.getAdditionalCapturedView(this.state.auto_id);
        }

        if (this.state.modalType == "notes") {
            this.getTeamNotesView(this.state.auto_id);
        }
    };

    getJobDescriptionView = (id) => { };
    getAdditionalCapturedView = (id) => {
        let recordlist = this.state.lists.findIndex((list) => list.auto_id === id);

        let modaldata = this.state.lists[recordlist]["additionl_captured"];

        Object.keys(modaldata).map(function () { });
    };
    getTeamNotesView = (id) => { };

    downloadCSV = (event, done) => {
        let params = {};
        let duration=0;
        params["chatstatus"] = this.state.chatstatus;
        params["chatfrequency"] = this.state.chatfrequency;
        params["strsearch"] = this.state.q;
        params["startdaterange"] = this.state.startdaterange;
        params["enddaterange"] = this.state.enddaterange;
        var end = moment(this.state.enddaterange);
        var now = moment(this.state.startdaterange);
        duration = end.diff(now,'days');
        let list = this.state.lists;
        let selected_arr = [];
        list.filter(function (key) {
            if (key["checked"] == true) {
                selected_arr.push(key["auto_id"]);
            }
        });
        this.setState({ loading: true });
        let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
        let clientTimeZone = u.substring(0, 3) + ":" + u.substring(3, u.length);
        let time_zone = clientTimeZone;
        let params1 = {...params, user_id: this.props.user.user_id,chatBotId: this.props.user.chatBot_id,timezone: time_zone,call_type: this.getApiCallType()};
        params["timezone"]=time_zone;
        params1["call_type"] = this.getApiCallType();
        params1["workspace_id"] = this.state.selectedWorkspace;
        if((this.state.chatfrequency==="daterange" && duration>90) || this.state.chatfrequency=='pastyear' ){
            api.transcriptchatlist.getvoiceChatExport(params1).then((data) => {
                if(data.status){
					this.setState({loading: false,alert_msg:'The CSV file will be available for download soon. Please refresh the page after 10 minutes.',requestedFiles:[]});
                    setTimeout(() => {
                        this.setState({alert_msg:''});
                    }, 5000);
                }

            });

        }else{
            let id = this.isSmsMode()
                ? "smscampaigncsv"
                : this.props.call_type == "inbound"
                ? "inboundphonechatcsv"
                : "outboundphonechatcsv";
            params["call_type"] = this.getApiCallType();
            params["workspace_id"] = this.state.selectedWorkspace;
            params["selectallcheckbox"] = selected_arr.length > 0 ? "false" : "true";
            params["chatidscheck"] = JSON.stringify(selected_arr);
            api.transcriptchatlist.getVoiceCSVData(params).then((data) => {
                try {
                    // getVoiceCSVData already extracts resp.data, so data is the response body
                    // The endpoint returns { data: [...] } or { status: true, data: [...] }
                    const csvData = data?.data?.data ?? data?.data ?? data;
                    if (!csvData || !Array.isArray(csvData)) {
                        toast.error("No data available to export.");
                        this.setState({ loading: false });
                        return;
                    }
                    this.setState(
                        {
                            csvdata: csvData,
                        },
                        function () {
                            setTimeout(
                                function () {
                                    const element = document.querySelector("#"+id);
                                    if (element) {
                                        element.click();
                                    }
                                    this.setState({ loading: false });
                                }.bind(this),
                                1000
                            );
                        }
                    );
                } catch (err) {
                    toast.error("Failed to export CSV.");
                    this.setState({ loading: false });
                }
            });
        }



    };

    openCustomPopup=(search)=>{
        this.setState({openCustomModal:true,modalstatus:false});
      }

      closeCustomPopup=()=>{
        this.setState({openCustomModal:false,parsed_data:[],custom_search:[],custom_searchdata:[],curid:"",existdata:[]});
    }

    checkAll = (e) => {
        let datalist = this.state.lists;
        datalist.map(function (list, index) {
            list["checked"] = e.target.checked;
        });
        this.setState({
            datatableRows: datalist.map((list, index) => this.buildDatatableRow(list, index)),
            lists: datalist,
        });
    };

    checkboxChangeEvent = (auto_id) => {
        let datalist = this.state.lists;
        let recordlist = datalist.findIndex((list) => list.auto_id === auto_id);

        if (datalist[recordlist]["checked"]) {
            datalist[recordlist]["checked"] = false;
        } else {
            datalist[recordlist]["checked"] = true;
        }

        this.setState({
            datatableRows: datalist.map((list, index) => this.buildDatatableRow(list, index)),
            lists: datalist,
        });

        //  let array=this.state.checkedboxes;
        // const index = this.state.checkedboxes.indexOf(auto_id);
        // if (index > -1) {
        //   array.splice(index, 1);
        // }else{
        //   array.push(auto_id)
        // }

        // this.setState({
        //   checkedboxes:array
        // });
    };

    openHipaaRow = (auto_id) => {
        this.setState({ loading: true })
        api.manageUser.checkHipaaAccount({ user_id: this.props.user.user_id, email: this.props.user.email }).then((data) => {
            try {
                if (data.data.data.subaccount_id == "found") {
                    var type = "validate";
                } else {
                    var type = "register";
                }
                this.setState({
                    loading: false,
                    modalstatusHIPAA: true,
                    modaltitle:
                        "To view sensitive chat information, please enter your authorize email and PIN",
                    hipaaValidateObject: {
                        userId: this.props.user.user_id,
                        userType: "User",
                        via: "user",
                        auto_id: auto_id,
                        pin_email: this.props.user.email,
                        refId: auto_id,
                        chat_section: "voicecalllist",
                        type: type

                    },
                });
            } catch (err) { }
        });


    };

    openHipaaAfterRegister = auto_id => {
        this.setState({
            loading: false,
            modalstatusHIPAA: true,
            modaltitle:
                "To view sensitive chat information, please enter your authorize email and PIN",
            hipaaValidateObject: {
                userId: this.props.user.user_id,
                userType: "User",
                via: "user",
                auto_id: auto_id,
                pin_email: this.props.user.email,
                refId: auto_id,
                chat_section: "chatlist",
                type: "validate"

            },
        });
    }

    onValidHipaaSubmit = (auto_id) => {
        let datalist = this.state.lists;

        let recordlist = this.state.lists.findIndex(
            (list) => list.auto_id === auto_id
        );


        datalist[recordlist]["hippaOn"] = "none";
        this.setState({
            datatableRows: datalist.map((list, index) => (
                <DatatableRow
                    channgeEvent={this.checkboxChangeEvent}
                    key={index}
                    list={list}
                    viewAdditionalCaptured={this.viewAdditionalCaptured}
                    viewDetails={this.viewDetails}
                    viewSummary={this.viewSummary}
                    viewRecording={this.viewRecording}
                    viewNotes={this.viewNotes}
                    viewNoteshtml={this.viewNotesHtml}
                    openHipaaRow={this.openHipaaRow}
                    viewPaerseData={this.viewPaerseData}
                    reGenerateParseData={this.reGenerateParseData}
                    notificationDetails={this.notificationDetails}
                    viewWebhookData={this.viewWebhookData}
                    user_id={this.props.user.user_id}
                    call_type={this.props.call_type}
                />
            )),
            lists: datalist,
        });
        this.setState({
            chat: this.state.chat,
            chatLeftList: this.state.chatLeftList,
            modalstatusHIPAA: false,
            name: this.state.name,
        });
    }

    hipaaModalClose = e => {
        this.setState({
            modalstatusHIPAA: false,
        });
    }

    handleChangereport=(e)=>{
        let btn=true;
        let newtxt=e.target.value.trim();
        if(newtxt!==this.state.oldTxt || this.state.category !== this.state.oldCategory){
           btn=false;
        }
        if(newtxt.length===0 || !this.state.category){
            btn=true;
        }

        this.setState({reportcommnet:newtxt,reporterror:false,modalBtn:btn},()=>{ this.updatemodelBody();});
    }

    handleChangecategory = (e) => {
        this.setState({
        category: e.target.value,
        categoryError: !e.target.value // Set error if no category is selected
        });
        let btn = true;
        let newcategory = e.target.value.trim();
        if (newcategory !== this.state.oldCategory || this.state.reportcommnet !== this.state.oldTxt) {
            btn = false;
        }
        if (newcategory.length === 0 || this.state.reportcommnet.length === 0) {
            btn = true;
        }
        this.setState({ category: newcategory, categoryError: false, modalBtn: btn }, () => {
            this.updatemodelBody();
        });
    };

    updatemodelBody = () => {
        let body = (<form id="notesForm1" method="post">
            <Message
                color={this.state.responseError ? "red" : "teal"}
                style={{
                    display: this.state.reportstatus?.length ? "block" : "none",
                    marginTop: 30,
                }}
            >
                {this.state.reportstatus}
            </Message>
             <div className="form-group" style={{ marginBottom: "20px" }}>
                <label htmlFor="category" className="form-label">
                    Category
                </label>
                <select
                                    className={
                                        this.state.categoryError
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    name="category"
                                    required
                                    value={this.state.category} // Bind the select value to state
                                    onChange={(e) => this.handleChangecategory(e)}
                                >
                                    <option value="" disabled>Select Category</option>
                                    <option value="1">How the agent guides the conversation</option>
                                    <option value="2">Information or FAQs need to be updated</option>
                                    <option value="3">Notification or escalation issue</option>
                                    <option value="4">Voice, audio, or tech issue</option>
                                    <option value="5">Other or not sure</option>
                                </select>
                                {this.state.categoryError && (
                                    <CustomErrorField
                                        message="This field is required"
                                        id="category-error"
                                        className="error invalid-feedback"
                                    />
                                )}
                            </div>
            {this.state.category && (
            <div className="form-group">
                <label htmlFor="notes" className="form-label">
                   Please provide additional details why this {this.isSmsMode() ? "conversation" : "call"} needs training?
                </label>
                <textarea rows="5" onChange={(e) => this.handleChangereport(e)} name="reportcommnet" id="notes" placeholder="Write notes here ..." defaultValue={this.state.reportcommnet} className={
                    this.state.reporterror
                        ? "form-control is-invalid"
                        : "form-control"}></textarea>
                {this.state.reporterror && <CustomErrorField
                    message="This field is required"
                    id="help-error"
                    className="error invalid-feedback"
                />
                }
            </div>
            )}
            {Array.isArray(this.state.emailList) && this.state.emailList.length > 0 && (
                <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                    <strong style={{ fontSize: "16px", color: "#000", marginBottom: "5px", display: "block" }}>
                        The emails that will be notified when a resolution takes place:
                    </strong>
                    <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                        {this.state.emailList.map((item, index) => (
                            <li
                                key={index}
                                style={{
                                    padding: "8px 0",
                                    fontSize: "14px",
                                    color: "#333",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    borderBottom: "1px solid #ddd"
                                }}
                            >
                                <span>{item.email} | {item.name}</span>
                                <button
                                  onClick={(event) => this.openDeleteModal(event,item.id)}
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        cursor: "pointer",
                                        color: "red",
                                        fontSize: "18px",
                                        marginLeft: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "5px"
                                    }}
                                    title="Delete"
                                >
                                    <i className="la la-trash red" title="Delete"></i> {/* Font Awesome Trash Icon */}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            <div className="form-group">
                <button
                    type="button"
                    onClick={this.addEmailField}
                    style={{ width: '40%', marginTop: '20px', marginBottom: '20px' }}
                    className="btn linear-gradient yr-submitbtn btn-md sbold btn-block"
                >
                 + Add Additional Email
                </button>
            </div>
            <div style={{ marginTop: "5px" }} className="form-group">
                {this.state.emails.map((item, index) => (
                    <div key={index} style={{ display: "flex", flexDirection: "column", gap: "5px", marginBottom: "10px" }}>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <div style={{ flex: 1 }}>
                                <input
                                    type="text"
                                    placeholder="Enter Name"
                                    value={item.name}
                                    onChange={(e) => this.handleNameChange(index, e)}
                                    style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
                                />
                                {this.state.errors[index]?.name && (
                                    <small style={{ color: "red", display: "block", marginTop: "3px" }}>
                                        {this.state.errors[index].name}
                                    </small>
                                )}
                            </div>

                            <div style={{ flex: 1 }}>
                                <input
                                    type="email"
                                    placeholder="Enter Email"
                                    value={item.email}
                                    onChange={(e) => this.handleEmailChange(index, e)}
                                    style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
                                />
                                {this.state.errors[index]?.email && (
                                    <small style={{ color: "red", display: "block", marginTop: "3px" }}>
                                        {this.state.errors[index].email}
                                    </small>
                                )}
                            </div>

                            {this.state.emails.length && (
                                <button
                                    style={{
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                    }}
                                    type="button"
                                    className="icon-btn-spl"
                                    onClick={(event) => this.removeEmailField(index, event)}
                                >
                                    <i className="la la-trash red" style={{ position: "relative", top: "-5px" }} title="Delete"></i>
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <div className="form-group">
                <button
                    disabled={this.state.modalBtn}
                    type="button"
                    onClick={(e) => {
                        this.setState({ modalBtn: true }, () => {
                            this.updatemodelBody();
                        });
                        this.saveReport(e);
                    }}
                    style={{ width: '100%', marginTop: '20px' }}
                    className="btn linear-gradient yr-submitbtn btn-md sbold btn-block"
                >
                    {this.state.loading ? "Processing..." : "Submit"}
                </button>
            </div>
        </form>
        );

        this.setState({ modalbody: body, loading: false, errors: {} });
        return body;
    };


    saveReport = (e) => {
        e.preventDefault();
        let note = this.state.reportcommnet;
        let category = this.state.category;

        this.setState({ loading: true, modalBtn: true });
        this.setState({ errors: {} });

        let errors = {};

        this.state.emails.forEach((item, index) => {
            if (!item.name.trim()) {
                errors[index] = { ...errors[index], name: "This is a required field." };
            }
            if (!item.email.trim()) {
                errors[index] = { ...errors[index], email: "This is a required field." };
            } else if (!/^\S+@\S+\.\S+$/.test(item.email)) {
                errors[index] = { ...errors[index], email: "Invalid email format" };
            }
        });

        if (Object.keys(errors).length > 0) {
            this.setState({ errors, loading: false });
            return;
        }

        if (note.length !== 0 && category) {
            let recordlist = this.state.lists.filter(
                (list) => list.auto_id === this.state.auto_id
            );
            const payload = {
                id: this.state.auto_id,
                report: note,
                emails: this.state.emails.map(item => item.email),
                names: this.state.emails.map(item => item.name),
                category: category,
                call_id:recordlist[0].log_id ?? '',
                ...(this.isSmsMode() ? { type: "sms" } : {}),
            };

            api.chatlist.savechatReportVoice(payload).then((data) => {
                try {
                    if (data.status) {
                        this.setState({
                            reportcommnet: '',
                            auto_id: '',
                            category: '',
                            reporterror: false,
                            categoryError:false,
                            responseError: false,
                            modaltitle: this.isSmsMode() ? "Report SMS For Training" : "Report Call For Training",
                            reportstatus: data.message,
                            loading: false,
                            emails: [],
                            oldCategory: ''
                        });

                        setTimeout(() => {
                            this.setState({ modalstatus: false, reportstatus: "" });
                        }, 3000);
                    }else{
                        this.setState({
                            responseError: true,
                            modaltitle: this.isSmsMode() ? "Report SMS For Training" : "Report Call For Training",
                            reportstatus: data.message,
                            loading: false,
                            reporterror: false,
                            categoryError: false
                        });
                        setTimeout(() => {
                            this.setState({ modalstatus: true, reportstatus: "", responseError: false, });
                        }, 3000);
                    }
                    this.updatemodelBody();
                } catch (err) {
                }
            });
        } else {
            this.setState({ reporterror: true, loading: false, responseError: false, });
            this.setState({ categoryError: true, loading: false, responseError: false, });
            this.updatemodelBody();
        }
    };
    notificationDetails=(id)=>{
        this.setState({loading:true});
        let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
        let clientTimeZone = u.substring(0, 3) + ":" + u.substring(3, u.length);
        let time_zone = clientTimeZone;
        api.transcriptchatlist.viewVoiceLog({ auto_id: id,timezone:time_zone}).then((data1) => {
            try {
                let stateobj={
                    loading: false,
                    modalstatus: true,
                    modaltitle: "",
                    modalfooter: "",
                    maxWidth:680,
                    modalbody: (
                        Object.keys(data1?.data).length  ?
                        <div className="row tracklogtable" style={{height:'42vh',overflow:'hidden auto',width:'650px'}}><Table id="additional_captured" style={{maxHeight:'500px',overflowY:'Auto',border: '1px solid #dddddd !important'}}>
                            {/* increase column width type and status */}


                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell >Name/Email or Number</Table.HeaderCell>
                                        <Table.HeaderCell className="increase-col-width" >Type</Table.HeaderCell>
                                        <Table.HeaderCell className="increase-col-width">Status</Table.HeaderCell>
                                        <Table.HeaderCell>Date/Time</Table.HeaderCell>
                                        <Table.HeaderCell className="col-col-100" >Viewed Time</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                {data1?.data.map(function(arr,index){
                                        let log=typeof arr?.log!='undefined' && typeof arr?.log=='string' ? JSON.parse(arr?.log): arr?.log;
                                        return (
                                            <Table.Row key={index}>
                                                <Table.Cell >{arr?.name}/{arr?.email_number}</Table.Cell>
                                                <Table.Cell className="increase-col-width" >{arr?.type=='Sms'? 'SMS':arr?.type}</Table.Cell>
                                                {arr?.status!=="Undelivered" && arr?.status!=="Failed" ?
                                                    <Table.Cell className="increase-col-width" >{arr?.status}</Table.Cell>:
                                                    <Table.Cell className="increase-col-width" >{arr?.status}&nbsp;<br/>{isNaN(log?.ErrorCode) ?
                                                        <span><strong>{log?.ErrorCode}</strong></span>:
                                                        typeof twl_errs[log?.ErrorCode]!=='undefined' ? <b>{twl_errs[log?.ErrorCode]}</b>:<span>Error:<a  rel="noreferrer" title="Check error message" target="_blank" href={`https://www.twilio.com/docs/api/errors/${log?.ErrorCode}`}>{typeof twl_errs[log?.ErrorCode]!=='undefined'? twl_errs[log?.ErrorCode]:log?.ErrorCode}</a></span>}
                                                    </Table.Cell>
                                                }
                                                <Table.Cell>{arr?.updatedat}</Table.Cell>
                                                <Table.Cell>{arr?.viewed_time}</Table.Cell>
                                            </Table.Row>
                                        )
                                    })
                                }
                                </Table.Body>
                            </Table></div> : <>
                                <h2>No data available.</h2>
                            </>
                    ),
                    modalTranscript: false
                };

                this.setState(stateobj,() => {this.changeTableRowBackground(id);});
                return false;

            } catch (err) {

            }
        });

    }

    viewWebhookData = (auto_id, call_id) => {
        if (!call_id) {
            toast.error("No call ID available for this record.");
            return;
        }
        this.setState({ loading: true });
        api.transcriptchatlist
            .getVoiceWebhookData({ call_id })
            .then((res) => {
                let display = res;
                if (res && typeof res === "object" && res.data !== undefined && res.data !== null) {
                    display = res.data;
                }
                const recordIdx = this.state.lists.findIndex(
                    (item) => item.auto_id === auto_id || item.id === auto_id
                );
                const list = recordIdx >= 0 ? this.state.lists[recordIdx] : {};
                this.setState(
                    {
                        loading: false,
                        modalstatus: true,
                        modaltitle: "Webhook Data",
                        modalfooter: "",
                        maxWidth: 720,
                        modalbody: <WebhookDataContent data={display} />,
                    modalTranscript: false
                    },
                    () => this.changeTableRowBackground(auto_id)
                );
            })
            .catch(() => {
                this.setState({ loading: false });
                toast.error("Could not load webhook data.");
            });
    };

    showtrainlogModal = (id) => {
        this.setState({ loading: true });
        api.chatlist.getTrainingLogVoice({ id, ...(this.isSmsMode() ? { type: "sms" } : {}) }).then((data) => {
            try {
                let msg = data.data;
                let category = data.category_id || '';
                let users = data.users || [];
                let emails = users.map(user => ({
                    id: user.id || "",
                    email: user.email || "",
                    name: user.name || ""
                }));
                this.setState({ reportcommnet: msg, category: category, oldCategory: category, loading: false,oldTxt:msg, emailList: emails, });
                let body = this.updatemodelBody();
                this.setState({
                    loading: false,
                    modalstatus: true,
                    modaltitle: this.isSmsMode() ? "Report SMS For Training" : "Report Call For Training",
                    modalfooter: "",
                    modalbody: body,
                    responseError: false,
                    reporterror: false,
                    categoryError:false,
                    modalTranscript: false,
                });
            } catch (err) { }
        });
    }

    // Open modal and store selected user ID
    openDeleteModal = (event,id) => {
        event.preventDefault();
        this.setState({ isModalOpen: true, selectedId: id });
      };


      confirmDeleteUser = () => {
        const { selectedId, emailList } = this.state;
        if (!selectedId) return;

        api.manageUser
            .deleteReportedchatListMember({ id: selectedId })
            .then(() => {
                const updatedList = emailList.filter((list) => list.id !== selectedId);
                this.setState({
                    emailList: updatedList,
                    isModalOpen: false,
                    selectedId: null,
                    modalstatus: true,
                    responseError: false,
                    reportstatus: "The email has been removed successfully.",
                }, () => {
                    setTimeout(() => {
                        this.setState({ modalstatus: false, reportstatus: "",emails: [] });
                    }, 3000);
                });
                this.updatemodelBody();
            })
            .catch((error) => {
                this.setState({ responseError: true, modalstatus: true, isModalOpen: false });
            });
    };

    render() {
return (
            <div>
<ConfirmationModal
          open={this.state.isModalOpen}
          onClose={() => this.setState({ isModalOpen: false, selectedId: null })}
          onConfirm={this.confirmDeleteUser}
        />
                {this.state.alert_msg && <div className="alert alert-success">{this.state.alert_msg}</div>}

                <ChatFilter
                    filter={{
                        chatfrequency: this.state.chatfrequency,
                        strsearch: this.state.q,
                        startdaterange: this.state.startdaterange,
                        enddaterange: this.state.enddaterange,
                    }}
                    totalCount={this.state.totalCount}
                    onSubmitFilter={this.onSubmitFilter}
                    loading={this.state.loading}
                    onSubmitFilterDateReange={this.onSubmitFilterDateReange}
                    csvdata={this.state.csvdata}
                    dowloadcsv={this.downloadCSV}
                    requestedFiles={this.state.requestedFiles}
                    showDarerangeErrorMessage={this.showDarerangeErrorMessage}
                    workspaceList={this.state.workspaceList}
                    selectedWorkspace={this.state.selectedWorkspace}
                    call_type={this.props.call_type}
                    isPLG={this.props.isPLG}
                    showStatusFilter={false}

                />
    <Segment style={{ width: "100%",maxWidth: "calc(96vw)" }}>
                    {this.state.loading && <div className="ui loading form"></div>}

                    <DatatableTable
                        lists={this.state.lists}
                        datatableHeader={this.getTableHeader()}
                        datatableRows={this.state.datatableRows}
                        totalCount={this.state.totalCount}
                        totalPages={Math.ceil(this.state.totalCount / this.state._limit)}
                        currentPage={this.state._page}
                        onChangePage={this.onChangePage}
                        column={this.state._sort}
                        direction={DatatableList.directionConverter(this.state._order)}
                        handleSort={this.handleSort}
                        onChangeLimit={this.onChangeLimit}
                        limit={this.state._limit.toString()}
                        checkAll={this.checkAll}
                        call_type={this.props.call_type}
                    />
                </Segment>
                <DatatablePageSizeSelect
                    limit={this.state._limit.toString()}
                    onChangeLimit={this.onChangeLimit}
                />{" "}
                Showing 1 - {this.state._limit.toString()} of {this.state.totalCount}
                <Pagination
                    totalPages={Math.ceil(this.state.totalCount / this.state._limit)}
                    activePage={this.state._page}
                    onPageChange={this.onChangePage}
                />
                <Modal
                    show={this.state.modalstatus}
                    footer={this.state.modalfooter}
                    onclose={this.modalClose}
                    title={this.state.modaltitle}
                    body={this.state.modalbody}
                    modaltranscript={this.state.modalTranscript}
                    isgpt={this.state.modalTranscript ? 1 : 0}
                    showtrainlogModal={this.showtrainlogModal}
                    auto_id={this.state.auto_id}
                    loading={this.state.loading}
                    custom_search={this.state.custom_search}
                    openCustomPopup={this.openCustomPopup}
                    parsed_data={typeof this.state.parsed_data!="undefined" ? this.state.parsed_data : {}}
                    parsebtnName={this.state.parsebtnName ?? ""}
                    showNotesForm={this.showNotesForm}
                    maxWidth={this.state.maxWidth}
                    hideSmsTranscriptControls={this.state.hideSmsTranscriptControls}
                    isSmsMode={this.isSmsMode()}
                />
                <CSVLink
                    id={this.isSmsMode() ? "smscampaigncsv" : this.props.call_type=="inbound" ? "inboundphonechatcsv" : "outboundphonechatcsv"}
                    data={this.state.csvdata}
                    filename={this.isSmsMode() ? `sms-campaign-export-${moment().format("YYYYMMDD-HHmmss")}.csv` : this.props.call_type=="inbound" ? "inboundphonecalls.csv" : "outboundphonecalls.csv"}
                    className="hidden"
                    target="_blank"
                />
                <DialogBoxHipaaPin
                    email={this.props.user.email}
                    obj={this.state}
                    modalClose={this.hipaaModalClose}
                    onValidHipaaSubmit={this.onValidHipaaSubmit}
                    openHipaaAfterRegister={this.openHipaaAfterRegister}
                />
                <DialogBoxDetail
                    obj={{ modalmessage: "Are you sure you want to delete?" }}
                    show={this.state.confirmDeleteNoteShow}
                    title="Confirm your action"
                    modalType="DeleteNote"
                    modalClose={this.confirmDeleteNoteClose}
                    buttonmsg={{ submit: "Yes", cancel: "No" }}
                    modalbuttofun={this.onConfirmDeleteNote}
                    loading={this.state.modalFormLoader}
                />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
 {(typeof this.state.custom_search!="undefined" && typeof this.state.custom_searchdata!="undefined" && typeof this.state.parsed_data!="undefined" )  && <CustomModel
                    show={this.state.openCustomModal}
                    modalClose={this.closeCustomPopup}
                    custom_search={this.state.custom_search}
                    custom_searchdata={this.state.custom_searchdata}
                    parsed_data={this.state.parsed_data}
                    exist_data={this.state.existdata}
                    title="Push Data Manually"
                    curid={this.state.curid}
                    module='voice'
                    parsed_config={this.state.parsed_config}
                    is_required={this.state.is_required}
                    date_required={this.state.date_required}
                    time_zone={this.state.user_timezone}
                    job_description={this.state.job_description}
                    use_address={this.state.use_address}
                />}
            </div>
        );
    }
}
